var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeliveryStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 47,
    viewBox: "0 0 39 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3485_21864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6467 39.8347C16.6467 39.8347 3.33301 28.8481 3.33301 18.0375C3.33301 14.2261 4.87824 10.5707 7.62878 7.87567C10.3793 5.18059 14.1098 3.6665 17.9997 3.6665C21.8895 3.6665 25.62 5.18059 28.3706 7.87567C31.1211 10.5707 32.6663 14.2261 32.6663 18.0375C32.6663 28.8481 19.3527 39.8347 19.3527 39.8347C18.612 40.5029 17.3928 40.4957 16.6467 39.8347Z",
    fill: "#4D2DEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8426 40.4028L19.8727 40.3776C19.8994 40.3552 19.9383 40.3224 19.9887 40.2795C20.0894 40.1936 20.2357 40.0675 20.4212 39.9036C20.7922 39.576 21.32 39.0975 21.9525 38.49C23.2165 37.2759 24.9031 35.5419 26.5917 33.4629C29.9403 29.3401 33.4163 23.7163 33.4163 18.0375C33.4163 14.0222 31.7883 10.1745 28.8955 7.33996C26.0032 4.50597 22.0836 2.9165 17.9997 2.9165C13.9158 2.9165 9.99618 4.50597 7.10387 7.33996C4.21105 10.1745 2.58301 14.0222 2.58301 18.0375C2.58301 23.7163 6.05909 29.3401 9.40767 33.4629C11.0962 35.5419 12.7829 37.2759 14.0469 38.49C14.6793 39.0975 15.2072 39.576 15.5781 39.9036C15.7636 40.0675 15.91 40.1936 16.0107 40.2795C16.061 40.3224 16.0999 40.3552 16.1267 40.3776L16.1575 40.4033L16.1592 40.4048C17.1813 41.3011 18.8146 41.3181 19.8426 40.4028Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3485_21864",
    x: 0.333008,
    y: 0.666504,
    width: 38.333,
    height: 45.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3485_21864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3485_21864",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeliveryStart);
export default __webpack_public_path__ + "static/media/ic_delivery_start.3bcfe0ebab0ea2a5049445160ba4f7a5.svg";
export { ForwardRef as ReactComponent };